module.exports = __webpack_public_path__ + "img/zicaipingtai.409a445f.png";